export default "__VITE_ASSET__f7e772b2__"